import React from 'react';
import { Card, CardContent, CardMedia, Box, Button, Typography, Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ResponsiveCard = ({title, description, button1, button2, imageUrl}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Card 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center',
                margin: 0,
                padding: 0,
                border: 0,
                textAlign: 'center',
                justifyContent: 'center',
                borderRadius: 3,
                boxShadow: 3,
                minHeight: 420,
                width: '100%',
                maxWidth: { xs: '100%', sm: 370 },
                mx: { xs: 1, sm: 'auto' },
            }}
        >
            {/* Card Media Section (Image at top) */}
            <CardMedia
                component="img"
                sx={{ 
                    width: '100%',
                    height: isMobile ? 180 : 200,
                    objectFit: 'cover',
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                }}
                image={imageUrl}
                alt="Card image"
            />
            {/* Card Content Section (Title, Description, Buttons) */}
            <CardContent sx={{ display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'center', width: '100%', p: 3 }}>
                <Typography
                    variant="h5"
                    component="div"
                    color="textPrimary"
                    fontWeight={700}
                    sx={{textAlign: 'center', mb: 2, mt: 1}}
                >
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3, minHeight: 48 }}>
                    {description}
                </Typography>
                <Stack direction="row" spacing={2} sx={{width: '100%'}} justifyContent='center'>
                    <Button
                        variant="outlined"
                        href={button1.link}
                        sx={{ minWidth: 110 }}
                    >
                        {button1.text}
                    </Button>
                    <Button
                        variant="outlined"
                        href={button2.link}
                        sx={{ minWidth: 110 }}
                    >
                        {button2.text}
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default ResponsiveCard;
